import Layout from '@layout/Index'

export const payConditions = [
  {
    path: '/pay-conditions',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "pay-conditions-table" */ './pages/PayConditionsTable.vue'),
        meta: {
          title: '账期列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "pay-conditions-form" */ './pages/PayConditionsForm.vue'),
        meta: {
          title: '添加账期',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "pay-conditions-form" */ './pages/PayConditionsForm.vue'),
        meta: {
          title: '修改账期',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "pay-conditions-detail" */ './pages/PayConditionsDetail.vue'),
        meta: {
          title: '账期详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/pay-conditions/pay-conditions.route.js